module.exports = __webpack_public_path__ + "img/9.b9c40a14.png";